import { render, staticRenderFns } from "./contactWayState.vue?vue&type=template&id=4a32fdd8&scoped=true"
import script from "./contactWayState.vue?vue&type=script&lang=js"
export * from "./contactWayState.vue?vue&type=script&lang=js"
import style0 from "./contactWayState.vue?vue&type=style&index=0&id=4a32fdd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a32fdd8",
  null
  
)

export default component.exports